import React, { useCallback, useContext, useEffect, useState } from "react";
import "./style.scss";
import { Input, message, Select, Spin } from "antd";
import { useDropzone } from "react-dropzone";
import uploadImage from "../../../assets/CreateCategory/upload.svg";
import CustomDropZone from "../../../common/CustomDropZone";
import dividerImage from "../../../assets/CreateCategory/divider.svg";
import guidelinesApi from "../../../apis/guidelines";
import Button from "../../../common/Button";
import {
  useCreateNewAngle,
  useGetAllShootTypes,
} from "../../../hooks/useGuidelines";
import { GuidelinesSelectedCategoryContext } from "../../../context/guidelinesProvider";

const CreateAngel = ({ isAngleCreated, setIsCreateAngle }) => {
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [fileUpload, setFileUpload] = useState({});
  const { getAnglePresignedUrl, getThumbPathOfImage } = guidelinesApi;
  const {
    guide_selectedCategoryName,
    guide_selectedSubCategoryName,
    guide_selectedCategoryId,
    guide_selectedSubCategoryId,
    guide_selectedClientId,
  } = useContext(GuidelinesSelectedCategoryContext);
  const [formInput, setFormInput] = useState({
    angleName: "",
    shootType: "",
    category: guide_selectedCategoryName,
    subCategory: guide_selectedSubCategoryName,
    image: "",
  });
  const [shootTypeList, setShootTypeList] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const allowedExtensions = ["jpg", "jpeg", "png", "webp"];
  const [selectShootType, setSelectShootType] = useState("");
  const [isImageLoading, setIsImageLoading] = useState(true);

  useEffect(() => {
    const lastSelectedShootType = sessionStorage.getItem(
      "lastSelectedShootType"
    );
    if (lastSelectedShootType) {
      setSelectShootType(lastSelectedShootType);
      setFormInput((prev) => ({
        ...prev,
        shootType: lastSelectedShootType,
      }));
    }
  }, []);

  const onSuccessGetShootTypes = (res) => {
    if (res.status === 200) {
      setShootTypeList(res.data.data);

      if (!selectShootType) {
        const defaultShootType = res?.data?.data[0]?.name;
        setSelectShootType(defaultShootType);
        setFormInput((prev) => ({
          ...prev,
          shootType: defaultShootType,
        }));
      }
    }
  };
  const onErrorGetShootTypes = (err) => {
    message.error(err);
  };
  const { data } = useGetAllShootTypes(
    "getAllSubCategories",
    onSuccessGetShootTypes,
    onErrorGetShootTypes
  );
  const onSuccessCreateAngle = (res) => {
    if (res.status === 200) {
      message.success("Angle created successfully.");
      setTimeout(() => {
        isAngleCreated();
      }, 500);
    }
  };
  const onErrorCreateAngle = (err) => {
    message.error(err);
  };
  const { mutate: createNewAngle } = useCreateNewAngle(
    onSuccessCreateAngle,
    onErrorCreateAngle
  );
  const validateForm = () => {
    const newErrors = {};
    if (!formInput.angleName.trim()) {
      newErrors.angelName = "Angel name is required.";
    }

    if (!formInput.image) {
      newErrors.image = "Image is required.";
    }
    setErrors(newErrors);
    setIsSubmitted(false);
    return Object.keys(newErrors).length === 0;
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/jpg": "",
      "image/png": "",
      "image/jpeg": "",
      "image/webp": "",
    },
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        setImageUrl("");
        setFileUpload({});
        setFormInput((prev) => ({
          ...prev,
          image: acceptedFiles[0],
        }));
      }
      setIsUploadingImage(true);
      setIsDragging(false);
      getKeyPresignedUrl(acceptedFiles);
    },
    multiple: false,
  });

  const onDropItems = async (files) => {
    if (files.length > 0) {
      setImageUrl("");
      setFileUpload({});
      setFormInput((prev) => ({
        ...prev,
        image: files[0],
      }));
    }
    setIsUploadingImage(true);
    setIsDragging(false);
    getKeyPresignedUrl(files);
  };

  const handleDragEnter = useCallback((e) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    setIsDragging(false);
  }, []);

  const renderDragAndDropSection = useCallback(
    () =>
      isDragging && (
        <CustomDropZone
          dropZoneClass={"uploaded_images_row"}
          onDropItems={onDropItems}
          isShowTextOnDrag={true}
          acceptingFormates={{
            "image/jpg": "",
            "image/png": "",
            "image/jpeg": "",
            "image/webp": "",
          }}
          handleDragLeave={handleDragLeave}
          multiple={false}
        />
      ),
    [isDragging, onDropItems, handleDragLeave]
  );

  const getUploadWrapper = () => {
    return (
      <>
        {isSuccess ? (
          <div className="upload_image_wrapper">
            {imageUrl ? (
              <>
                {isImageLoading && (
                  <div className="image-placeholder">Loading...</div>
                )}
                <img
                  src={imageUrl}
                  alt="Uploaded"
                  style={{ display: isImageLoading ? "none" : "block" }}
                  onLoad={handleImageLoad}
                />
              </>
            ) : (
              ""
            )}
            <div
              className="cross-icon"
              onClick={() => {
                setIsSuccess(false);
                setFormInput((prev) => ({
                  ...prev,
                  image: "", // Clear only the image field
                }));
              }}
            ></div>
          </div>
        ) : (
          <div className="upload_wrapper">
            <div className="category_image">
              <img src={uploadImage} alt="" />
              <p>Drag your category image</p>
            </div>
            <div className="or_image">
              <img src={dividerImage} alt="" />
            </div>
            <label className="browse" onClick={handleAreaClick}>
              Browse files
            </label>
            <input
              type="file"
              accept="image/png,image/jpg,image/jpeg, image/webp"
              id="file"
              onChange={(e) => handleUploadImage(e.target.files)}
              onClick={(e) => (e.target.value = null)}
              className="upload_more_images_btn_input"
            />
          </div>
        )}
      </>
    );
  };
  const getKeyPresignedUrl = async (file) => {
    let uploadSuccess = true;
    setIsSuccess(true);
    try {
      if (!file[0].name || !file[0].type) {
        uploadSuccess = false;
        setIsSuccess(false);
        throw new Error(
          "Invalid file detected. Ensure the file has a valid name and type."
        );
      }

      const resp = await getAnglePresignedUrl({
        filename: file[0].name,
        mimeType: file[0].type,
      });

      if (resp?.status !== 200 || !resp?.data?.key || !resp?.data?.url) {
        uploadSuccess = false;
        setIsSuccess(false);
        throw new Error("Invalid response from getPresignedUrl.");
      }

      const { key, url } = resp.data;

      const uploadResp = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": file[0].type,
        },
        body: file[0],
      });

      if (!uploadResp.ok) {
        uploadSuccess = false;
        setIsSuccess(false);
        throw new Error(`File upload failed with status: ${uploadResp.status}`);
      }
      if (uploadSuccess) {
        setIsSuccess(true);
        getThumbPathOfImage({
          key,
        }).then((resp) => {
          setImageUrl(resp?.data?.data?.thumbPath?.url);
        });
        const addFilesPayload = {
          image: {
            imagePath: {
              key,
            },
          },
        };
        setFileUpload(addFilesPayload);
        setIsSuccess(true);
        message.success("Image uploaded successfully.");
      } else {
        message.error("Some images failed to upload.");
      }
    } catch (err) {
      uploadSuccess = false;
      setIsSuccess(false);
      message.error(
        err?.response?.data?.message ||
          err.message ||
          "An error occurred during upload."
      );
    } finally {
      setIsUploadingImage(false);
    }
    return uploadSuccess;
  };
  const handleUploadImage = async (file) => {
    if (file.length > 0) {
      setImageUrl("");
      setFileUpload({});
      setFormInput((prev) => ({
        ...prev,
        image: file[0],
      }));
      setIsUploadingImage(true);
      getKeyPresignedUrl(file);
    }
  };

  const handleAreaClick = () => {
    document.getElementById("file")?.click();
  };

  const handleImageLoad = () => {
    setIsImageLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prev) => ({ ...prev, [name]: value }));
  };
  const handleSelectChange = (val) => {
    setSelectShootType(val);
    setFormInput((prev) => ({ ...prev, shootType: val }));
    sessionStorage.setItem("lastSelectedShootType", val);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitted(true);
      const payload = {
        reason: formInput.reason,
        shootType: formInput.shootType,
        category: guide_selectedCategoryId,
        subCategory: guide_selectedSubCategoryId,
        name: formInput.angleName,
        orgId: guide_selectedClientId,
        ...fileUpload,
      };
      createNewAngle(payload);
      setErrors({});
    } else {
      message.error("Please fix the errors in the form.");
    }
  };
  const handlePaste = async (e) => {
    const items = e.clipboardData.items;
    let foundImage = false;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (item.type.includes("image")) {
        foundImage = true;
        const blob = item.getAsFile();

        if (blob) {
          const file = new File(
            [blob],
            `pasted-image.${blob.type.split("/")[1]}`,
            { type: blob.type }
          );

          setImageUrl("");
          setFileUpload({});
          setFormInput((prev) => ({
            ...prev,
            image: file,
          }));
          setIsUploadingImage(true);
          getKeyPresignedUrl([file]);
        }
      }
    }

    if (!foundImage) {
      message.error("Pasted content is not an image.");
    }
  };
  return (
    <div className="create_angel_main_wrapper" onDragEnter={handleDragEnter}>
      <div className="create_angel_content">
        <form onSubmit={handleSubmit}>
          <div className="form_control">
            <label>
              Angle Name <sup>*</sup>
            </label>
            <input
              placeholder="Enter Angle Name"
              name="angleName"
              value={formInput.angleName}
              onChange={handleChange}
            />
            {errors.angelName && (
              <p className="error_message">{errors.angelName}</p>
            )}
          </div>
          <div className="form_control">
            <label>
              Shoot Type <sup>*</sup>
            </label>
            <Select
              onChange={handleSelectChange}
              value={
                selectShootType.length === 1
                  ? selectShootType
                  : formInput.shootType
              }
              style={{ height: "50px" }}
            >
              {shootTypeList.map((shootType, index) => {
                return (
                  <Select.Option value={shootType.name}>
                    {shootType.name}
                  </Select.Option>
                );
              })}
            </Select>
            {errors.shootType && (
              <p className="error_message">{errors.shootType}</p>
            )}
          </div>
          <div className="control_wrapper">
            <div className="form_control">
              <label>
                Category <sup>*</sup>
              </label>
              <input
                placeholder="Category"
                name="category"
                value={formInput.category}
                disabled
                className="input_disabled"
              />
              {errors.category && (
                <p className="error_message">{errors.category}</p>
              )}
            </div>
            <div className="form_control">
              <label>
                Sub Category <sup>*</sup>
              </label>
              <input
                placeholder="Sub Category"
                name="subCategory"
                value={formInput.subCategory}
                disabled
                className="input_disabled"
              />
              {errors.subCategory && (
                <p className="error_message">{errors.subCategory}</p>
              )}
            </div>
          </div>
          <div className="form_control">
            <label>
              Upload Image <sup>*</sup>
            </label>
            <div className="drop_down_wrapper" onPaste={handlePaste}>
              <div className="item_upload_wrapper">
                {isUploadingImage ? <Spin /> : getUploadWrapper()}
                {renderDragAndDropSection()}
              </div>
            </div>
            {errors.image && <p className="error_message">{errors.image}</p>}
          </div>

          <div className="action_wrapper">
            <button
              className="cancelBtn"
              onClick={() => setIsCreateAngle(false)}
            >
              {" "}
              Cancel
            </button>
            <Button
              text="Send for Approval"
              className="approvalBtn"
              isDisabled={
                !formInput.angleName || !formInput.shootType || !formInput.image
              }
              width="280px"
              height="60px"
            />
          </div>
        </form>
      </div>
      {renderDragAndDropSection()}
    </div>
  );
};
export default CreateAngel;
